import { Reminder } from 'data/firestore/agent/reminder/types';
import { CellWrapper, ClickableText } from './styled';

interface Props {
    value?: string;
    row?: Reminder;
    onClick?: (value: Reminder) => void;
}

const PurposeColumn = ({ value, onClick, row }: Props) => (
    <CellWrapper>
        <ClickableText onClick={() => onClick?.(row as Reminder)}>
            {value || '-'}
        </ClickableText>
    </CellWrapper>
);

export default PurposeColumn;
